<template>
    <div class="wrapper-forecast">
        <div class="forecast">
            <div class="table-responsive-lg">
                <table class="table table--overview">
                    <thead>
                        <tr>
                            <th>
                                Name
                            </th>
                            <th>
                                E-Mail
                            </th>
                            <th>
                                Site
                            </th>
                            <th>
                                Plan
                            </th>
                            <th>
                                Backuptest
                            </th>
                            <th>
                                SubTotal
                            </th>
                            <th>
                                Tax
                            </th>
                            <th>
                                Total
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in forecast.items" v-bind:key="index" v-bind="item">
                            <td>
                                {{ item.company }}
                            </td>
                            <td>
                                {{ item.email }}
                            </td>
                            <td>
                                {{ formatCurrency(item.site) }}
                            </td>
                            <td>
                                {{ formatCurrency(item.plan) }}
                            </td>
                            <td>
                                {{ formatCurrency(item.backuptest) }}
                            </td>
                            <td>
                                {{ formatCurrency(item.subtotal) }}
                            </td>
                            <td>
                                {{ formatCurrency(item.tax/100) }}
                            </td>
                            <td>
                                {{ formatCurrency(item.total) }}
                            </td>
                        </tr>

                        <tr v-if="forecast.forecast">
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                {{ site }}
                            </td>
                            <td>
                                {{ plan }}
                            </td>
                            <td>
                                {{ backuptest }}
                            </td>
                            <td>
                                {{ subtotal }}
                            </td>
                            <td>
                                {{ totaltax }}
                            </td>
                            <td>
                                {{ total }}
                            </td>
                        </tr>

                    </tbody>

                </table>
            </div>
        </div>
    </div>
</template>

<script>

import { mapActions, mapState, mapMutations } from 'vuex'

export default {

  name: 'ForeCast',

  computed: {
    ...mapState('invoice', ['forecast']),

    site () {
      return this.formatCurrency(this.forecast.forecast.site)
    },

    plan () {
      return this.formatCurrency(this.forecast.forecast.plan)
    },

    backuptest () {
      return this.formatCurrency(this.forecast.forecast.backuptest)
    },

    subtotal () {
      return this.formatCurrency(this.forecast.forecast.subtotal)
    },

    totaltax () {
      return this.formatCurrency(this.forecast.forecast.totaltax)
    },

    total () {
      return this.formatCurrency(this.forecast.forecast.total)
    }

  },

  methods: {
    ...mapActions('invoice', ['getForeCast']),

    ...mapMutations([
      'setViewname'
    ]),

    ...mapMutations('common', [
      'startLoading',
      'endLoading'
    ]),

    formatCurrency (value) {
      if (value === undefined) {
        return ''
      }

      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value / 100)
    }

  },

  mounted () {
    this.getForeCast().then(
      this.endLoading()
    )
  },

  created () {
    this.setViewname(this.$t('admin.forecast.viewtitle'))
  }
}
</script>
